import React from 'react';
import {
  compose,
  setDisplayName,
  withStateHandlers,
} from 'recompose';
import Steps from './Steps';
import { withBreakpoints } from '@ux/responsive';
import { Content, Display } from '@ux/typeface';
import TextButton, { Against, Size } from '@ux/text-button';
import Submit from '@ux/submit';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { createPaintbrushUrl } from '@ux/glyphs';
import { isTrue } from '@team-griffin/capra';
import { withStyles } from '@ux/style-utils';
import stylesheet from './Negotiate.stylesheet';
import * as r from 'ramda';

const PureNegotiate = ({
  form,
  styles,
  theme,
  price,
  showLegalTerms,
  currency,
  showMoreHeight,
  onShowMoreClick,
  afternicInBasket,
  // events
}) => (
  <form
    style={styles.root}
    onSubmit={form.handleSubmit}
  >
    <Content
      theme={theme}
      style={styles.body}
      component="article"
    >
      <section style={styles.text}>
        <p style={styles.paragraph}>
          <FormattedMessage id="dst.negotiate.v2.text"/>
        </p>
        <p style={styles.paragraph}>
          <TextButton
            theme={theme}
            type="button"
            against={Against.LIGHT}
            size={Size.LG}
            onClick={onShowMoreClick}
          >
            <FormattedMessage id="dst.negotiate.v2.showMore"/>
          </TextButton>
        </p>
        <Steps
          theme={theme}
          height={showMoreHeight}
        />
      </section>
      <section style={styles.cta}>
        <p style={styles.paragraph}>
          <FormattedMessage id="dst.negotiate.v2.productName"/>
          <Display
            style={styles.productPrice}
            theme={theme}
            component="div"
          >
            <span style={styles.price}>
              <FormattedNumber
                // eslint-disable-next-line react/style-prop-object
                style="currency"
                value={price}
                currency={currency}
              />
            </span>
            {' '}
            <span style={styles.priceTerm}>
              <FormattedMessage
                id="dst.negotiate.v2.priceTerm"
                values={{
                  asterisk: r.ifElse(
                    isTrue,
                    () => (
                      <FormattedMessage id="dst.negotiate.v2.legalAsterisk"/>
                    ),
                    r.always(''),
                  )(showLegalTerms),
                }}
              />
            </span>
          </Display>
        </p>
        <div style={styles.actions}>
          <Choose>
            <When condition={afternicInBasket}>
              <span style={styles.availability}>
                <span style={styles.availabilityText}>
                  <FormattedMessage id="dst.negotiate.v2.success"/>
                </span>
                <img
                  style={styles.icon}
                  src={createPaintbrushUrl(
                    'circleTick',
                    [ theme.palette.green01 ]
                  )}
                  aria-hidden="true"
                  alt="tick"
                />
              </span>
            </When>
            <Otherwise>
              <Submit
                theme={theme}
                formProps={form}
                block={true}
                glyph="circlePositive"
              >
                <span style={styles.buttonText}>
                  <FormattedMessage id="dst.negotiate.v2.submit"/>
                </span>
              </Submit>
            </Otherwise>
          </Choose>
        </div>
        <If condition={showLegalTerms}>
          <footer style={styles.legalText}>
            <FormattedMessage id="dst.negotiate.v2.legalText"/>
          </footer>
        </If>
      </section>
    </Content>
  </form>
);

const enhance = compose(
  setDisplayName('Negotiate'),
  withBreakpoints,
  withStyles(stylesheet),
  withStateHandlers({
    showMoreHeight: 0,
  }, {
    onShowMoreClick: ({ showMoreHeight }) => () => ({
      showMoreHeight: r.ifElse(
        r.equals(0),
        r.always('auto'),
        r.always(0),
      )(showMoreHeight),
    }),
  }),
);

export default enhance(PureNegotiate);
